module.exports = __webpack_public_path__ + "static/bg-cast-header-576-75c248e632ab79e504b742d7360fcf65.jpg";